<template>
  <div class="main">
    <toptab></toptab>
    <div class="newwhiteouter">
      <div id="demo" class="carousel slide" data-ride="carousel">
        <!-- 指示符 -->
        <ul class="carousel-indicators" style="bottom:-50px">
          <template v-for="(item,index) in projectbanner">
            <!-- <li data-target="#demo" :data-slide-to="index" class="active" :key="index"></li> -->
            <li data-target="#demo" :data-slide-to="index" :class="index==0? 'active':'' " :key="index"></li>
          </template>
        </ul>

        <!-- 轮播图片 -->
        <div class="carousel-inner">
          <template v-for="(item,index) in projectbanner">
            <!-- @click="goDeatil('projectdetail',item.id)" -->
            <div
              class="carousel-item"
              :class="index==0? 'active':'' "
              :key="index"
              :style="'background: #fff url('+item.image+') center center no-repeat;'"
            >
              <div class="text toppaddingalll">
                <div class="textitle animated fadeInUp">
                  <b>{{item.title}}</b>
                </div>
                <div class="textinfo animated fadeInUp">{{item.line}}</div>
                <!-- <div class="textimg animated fadeInUp">
                  <a href="javascript:void(0);">
                    <img src="/static/index/more2.png" />
                  </a>
                </div>-->
              </div>
              <div class="blackcover"></div>
            </div>
          </template>
        </div>
        <!-- 左右切换按钮 -->
        <a class="carousel-control-prev ggg" href="#demo" data-slide="prev" style="z-index:40">
          <img src="/static/左箭头.png" style="width:60px;height:70px" />
        </a>
        <a class="carousel-control-next ggg" href="#demo" data-slide="next" style="z-index:40">
          <img src="/static/右箭头.png" style="width:60px;height:70px" />
        </a>
      </div>
    </div>
    <div class="whiteouter paddingalll">
      <div class="itemlist" v-if="!isSmall">
        <template v-for="(item,index) in data">
          <indexitem :key="index" :project="item"></indexitem>
        </template>
      </div>
      <div class="itemlist" v-if="isSmall">
        <template v-for="(item,index) in data">
          <indexitemitem :key="index" :project="item"></indexitemitem>
        </template>
      </div>
    </div>
    <footeritem></footeritem>
  </div>
</template>

<script>
import toptab from "../components/top-tab-item";
import footeritem from "../components/footer-item";
import indexitem from "../components/project-item";
import indexitemitem from "../components/project-item copy";
import $ from 'jquery'
require('../../utils/count');
require('../../utils/toptab');
export default {
  components: {
    toptab,
    footeritem,
    indexitem,
    indexitemitem
  },
  data() {
    return {
      projectbanner: [],
      data: [],
      isSmall: false
    }
  },
  mounted() {
    this.loadData();
    this.$nextTick(() => {
      require('../../utils/home');
      this.$e.$on("smallWindow", () => {
        console.log(this.isSmall);
        this.isSmall = true
      })
      this.$e.$on("bigWindow", () => {
        console.log(this.isSmall);
        this.isSmall = false
      })
    })
  },
  beforeCreate() {
    // this.$router.go(0)
    // location.href = "/#/" + '?time=' + ((new Date()).getTime());
    if (window.isFirst) {
      // this.$router.go(0)
      window.location.reload()
    }
  },
  methods: {
    /**
     * 数据加载
     */
    loadData() {
      this.$axios.post(this.$url.getBanner, {})
        .then(res => {
          console.log(res.data);
          let { error_code, banners } = res.data;
          if (error_code == 2001) {
            this.projectbanner = banners
          }
        });
      this.$axios.post(this.$url.getColumn, {})
        .then(res => {
          console.log(res.data);
          let { error_code, columns } = res.data;
          if (error_code == 2001) {
            columns.forEach((v, i) => {
              if (i == 0) {
                v.url = "about"
              }
              if (i == 1) {
                v.url = "news"
              }
              if (i == 2) {
                v.url = "recruitment"
              }
            })
            this.data = columns

          }
        });
    },
  }
}
</script>

<style scoped>
/* @import "../css/padding.css"; */
@import "../css/animate.min.css";

.paddingalll {
  padding: 1rem 0;
}

.toppaddingalll {
  padding: 0;
}

@media (max-width: 1640px) {
  .paddingalll {
    padding: 1rem 1rem;
  }
  .toppaddingalll {
    padding: 0 1rem;
  }
}
@media (max-width: 1440px) {
  .paddingalll {
    padding: 1rem 0.6rem;
  }
  .toppaddingalll {
    padding: 0 0.6rem;
  }
}

.main {
  padding-top: 0.67rem;
}

#demo {
  width: 1920px;
  height: 900px;
  margin: 0 auto;
}
#demo .carousel-inner {
  width: 100%;
  height: 900px;
  /* position: relative; */
}
#demo .carousel-inner .carousel-item {
  padding-top: 3rem;
  width: 100%;
  height: 900px;
  background-size: cover;
  position: relative;
}
#demo .carousel-inner .text {
  width: 1440px;
  /* margin: 0 auto; */
  font-size: 40px;
  color: white;
  z-index: 20;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

#demo .carousel-inner .text .textitle {
}

#demo .carousel-inner .text .textinfo {
}

/* #demo .carousel-inner .text .textimg {
  width: 1.8rem;
  height: 0.46rem;
  margin-top: 1.5rem;
}

#demo .carousel-inner .text .textimg img {
  width: 1.8rem;
  height: 0.46rem;
} */

.blackcover {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(49, 50, 51, 0.5);
}

.textitle {
  font-size: 0.6rem;
  margin-bottom: 0.58rem;
  text-align: center;
}
.textinfo {
  font-size: 0.25rem;
  text-align: center;
  line-height: 0.4rem;
}

.newwhiteouter {
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  height: 900px;
}
.whiteouter {
  width: 100%;
  /* max-width: 1440px; */
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 1);
  /* padding: 1rem 0; */
}
.itemlist {
  width: 100%;
  margin: 0 auto;
  max-width: 1540px;
  /* padding: 1rem; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
@media (max-width: 1920px) {
  #demo {
    width: 100%;
  }

  #topdemo {
    width: 100%;
  }
  /* .itemlist {
    width: 100%;
  } */
}

@media (max-width: 1440px) {
  #demo .carousel-inner .text {
    width: 100%;
  }
}

@media (max-width: 992px) {
  .ggg {
    display: none;
  }
  .textinfo {
    font-size: 0.4rem;
  }

  .main {
    padding-top: 100px;
  }
}

/* 动画库 */
[class*="animation-"] {
  animation-duration: 0.5s;
  animation-timing-function: ease-out;
  animation-fill-mode: both;
}

.animation-scale-up {
  animation-name: scale-up;
}

@keyframes scale-up {
  0% {
    opacity: 0;
    transform: scale(0.2);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue